var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76304 4.05951C10.0669 3.28917 10.6303 2.62211 11.3757 2.15027C12.1211 1.67843 13.0117 1.42505 13.9248 1.42505C14.8379 1.42505 15.7285 1.67843 16.4739 2.15027C17.2193 2.62211 17.7827 3.28917 18.0866 4.05951M26.4248 6.69075H1.4248M23.9733 9.9798L23.2969 19.0576C23.0366 22.5492 22.9072 24.2951 21.6351 25.3594C20.363 26.4237 18.4057 26.425 14.4939 26.425H13.3557C9.44392 26.425 7.48657 26.425 6.21451 25.3594C4.94245 24.2951 4.81157 22.5492 4.55275 19.0576L3.87627 9.9798M10.2483 13.2689L10.9836 19.8469M17.6013 13.2689L16.866 19.8469",
    stroke: "#002954",
    strokeWidth: 2.85,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.7a12a56cdbe7ab15992a190b58078b81.svg";
export { ForwardRef as ReactComponent };